import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from "react-router-dom";

import { getTeamMember } from '../helper/restapi.js';

import { Loader } from './Loader.js';
import { Elements } from './Elements.js';

function withParams(Component) {
  return props => (
    <Component
      {...props}
      location={useLocation()}
      navigate={useNavigate()}
    />
  );
}

class Post extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      data: null, // ✅ instead of []
    };
  }

  async getPost(slug) {
    try {
      const response = await getTeamMember(slug);
      const member = response?.data?.data ?? null;

      // ✅ "fake 404" in payload (HTTP 200)
      const payloadStatus =
        member?.status ?? response?.data?.status ?? response?.data?.data?.status;

      if (!member || payloadStatus === 404 || payloadStatus === "404") {
        this.props.navigate("/seite-nicht-gefunden", { replace: true });
        return;
      }

      this.setState({
        data: member,
        isReady: true
      });
    } catch (error) {
      console.log(error);

      // ✅ real HTTP 404 (Axios)
      if (error?.response?.status === 404) {
        this.props.navigate("/seite-nicht-gefunden", { replace: true });
        return;
      }

      console.error("Ein Fehler ist aufgetreten:", error);
      this.setState({ isReady: true, data: null });
    }
  }

  componentDidMount() {
    let slug = this.props.location.pathname;
    slug = slug.substring(slug.lastIndexOf('/') + 1);
    this.getPost(slug);
  }

  render() {
    const { data, isReady } = this.state;

    if (!isReady) return <Loader />;

    // ✅ if ready but no data (non-404 error etc.)
    if (!data) return <Loader />;

    // ✅ safe image access
    const imageMd = data?.image?.sizes?.['banner-start'] || '';
    const imageLg = data?.image?.sizes?.['banner-start'] || '';

    // ✅ categories safe
    const categoriesArr = Array.isArray(data.categories) ? data.categories : [];
    const categories = categoriesArr.length ? categoriesArr.join(', ') : '';

    const info = Array.isArray(data.info) ? data.info : [];
    const likes = Array.isArray(data.likes) ? data.likes : [];
    const questions = Array.isArray(data.questions) ? data.questions : [];

    return (
      <>
        <Helmet>
          <title>{data.meta_title}</title>
          <meta name="description" content={data.meta_description} />
        </Helmet>

        <div className="banner_start banner_team team_detail">
          <div className="container picture">
            <picture>
              {/* ✅ only render sources if we have a url */}
              {imageMd && <source media="(max-width: 767px)" srcSet={imageMd} />}
              {imageLg && <source media="(max-width: 768px)" srcSet={imageLg} />}
              {imageLg && <img src={imageLg} alt="Radio Grün Weiß" />}
            </picture>
          </div>

          <div className="overlay">
            <div className="container">
              <div className="col-12 col-lg-6 offset-lg-6 p-0">
                <div className="row">
                  <div className="col-12">
                    <h1 className="slogan ">{data.name}</h1>

                    {categories && info.length > 0 && (
                      <div className="infobox">
                        <div className="categories">{categories}</div>

                        <div className="infos">
                          {info.map((item, index) => (
                            <div key={index} className="col-12 info">
                              <div className="q">{item.label}</div>
                              <div className="a">{item.value}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </div>

            <a href="#down" className="d-none d-xl-block scrolldown">
              <img src="/icon/arrow-down.svg" alt="" />
            </a>
          </div>
        </div>

        <div id="down"></div>

        <div className="container team-member">
          <div className="row">
            <div className="col-12 col-lg-4 likes mb-5 mb-lg-0">
              {likes.length > 0 && (
                <div className="inner h-100">
                  <h2>Lieblings...</h2>
                  {likes.map((item, index) => (
                    item?.value ? (
                      <div key={index} className="like">
                        <div className="q">{item.label}</div>
                        <div className="a" dangerouslySetInnerHTML={{ __html: item.value }} />
                      </div>
                    ) : null
                  ))}
                </div>
              )}
            </div>

            <div className="col-12 col-lg-8 questions mt-5 mt-lg-0">
              {questions.length > 0 && (
                <div className="inner">
                  <h2>12 Fragen</h2>
                  {questions.map((item, index) => (
                    item?.value ? (
                      <div key={index} className="question">
                        <div className="q">{item.label}</div>
                        <div className="a" dangerouslySetInnerHTML={{ __html: item.value }} />
                      </div>
                    ) : null
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withParams(Post);